import React, { useEffect } from "react";
import { Button } from "react-bulma-components";
import { CheckCircle, XCircle } from "lucide-react";

const SuccessMessage = ({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) => {
  if (!message) return null;
  if (typeof message !== "string") {
    console.warn("SuccessMessage: message should be a string");
    return null;
  }
  if (message.length > 100) {
    console.warn("SuccessMessage: message is too long");
    return null;
  }
  if (message.trim() === "") return null;
  if (typeof onClose !== "function") {
    console.warn("SuccessMessage: onClose should be a function");
    return null;
  }
  useEffect(() => {
    const timer = setTimeout(onClose, 5000); // Auto close after 5 seconds
    return () => clearTimeout(timer); // Cleanup timer on unmount or message change
  }, [message, onClose]);

  return (
    <div className="fixed bottom-4 left-4 bg-green-600/90 text-white p-4 rounded-md shadow-lg z-40000 flex items-center gap-2">
      <CheckCircle className="text-green-300 w-6 h-6" />
      <span>{message}</span>

      <button
        onClick={onClose}
        className="ml-4 text-green-200 hover:text-white"
      >
        <XCircle className="w-4 h-4" />
      </button>
    </div>
  );
};

export default SuccessMessage;
